module.exports = __webpack_public_path__ + "static/media/office_1.c322968c.jpg";